import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`You can enable this feature from your client-side by setting `}<inlineCode parentName="p">{`captureLogcat = true`}</inlineCode>{` in our `}<a parentName="p" {...{
        "href": "/docs/session-replay/installation?tab=Android#step-two-configure-replay-settings"
      }}>{`Android SDK config`}</a>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-android_kotlin"
      }}>{`val config = PostHogAndroidConfig(apiKey = "<ph_project_api_key>").apply {
    // Enable session recording. Requires enabling in your project settings as well.
    // Default is false.
    sessionReplay = true
    // Capture logs automatically. Default is true.
    sessionReplayConfig.captureLogcat = true
    ...
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      